import { render } from "./PendingPage.vue?vue&type=template&id=5372cf00&scoped=true"
import script from "./PendingPage.vue?vue&type=script&lang=js"
export * from "./PendingPage.vue?vue&type=script&lang=js"

import "./PendingPage.vue?vue&type=style&index=0&id=5372cf00&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5372cf00"]])

export default __exports__